import Symbol           from 'es6-symbol/polyfill';
import EventEmitter     from 'events';
import axios            from 'axios';

let singleton = Symbol();
let singletonEnforcer = Symbol();

class GamesService extends EventEmitter {

  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this._games = null;
    this._extensions = null;
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new GamesService(singletonEnforcer);
    }
    return this[singleton];
  }

  getHelps(params) {
    const seq = axios.get('/api/v2/games/help_texts', {params});
    seq.catch( console.error );
    return seq;
  }

  getTotalPrice(game, declaredValue, serviceType) {
    return axios.get(`/api/v2/price-for-selection`, { params: {
      game, declaredValue, serviceType
    }})
  }

  getAll() {
    if(this._games) return Promise.resolve(this._games);
    else return new Promise( (resolve, reject) => {
      axios.get('/api/v2/games').then(res => {
        this._games = res.data['hydra:member'];
        resolve(this._games);
      }).catch( (err) => {
        console.error(err);
        reject(err);
      });
    });
  }

  getExtensions(params) {
    const seq = axios.get('/api/v2/games/extensions', {params});
    seq.then(res => {
      this._extensions = res.data['hydra:member'];
    }).catch( console.error );
    return seq;
  }

  getBlocks(params) {
    const seq = axios.get('/api/v2/games/blocks', {params});
    seq.catch( console.error );
    return seq;
  }

  getCodeExt(params) {
    const seq = axios.get('/api/v2/games/extensions/codes', {params});
    seq.catch( console.error );
    return seq;
  }

  getCodesYGO(params) {
    const seq = axios.get('/api/v2/games/yugioh/languages', {params});
    seq.catch( console.error );
    return seq;
  }

  getLettersYGO(params) {
    const seq = axios.get('/api/v2/games/yugioh/letters', {params});
    seq.catch( console.error );
    return seq;
  }

  getSpecificities(params = {}) {
    params.isVisible = true;
    const seq = axios.get('/api/v2/games/specificities', {params});
    seq.catch( console.error );
    return seq;
  }

  getGame( value, key ) {
    if( this._games ) {
      for( let i = 0; i < this._games.length; i++) {
        if(this._games[i][key] === value) return this._games[i];
      }
    }
    return null;
  }

  getLanguage(languages, value, key ) {
    for( let i = 0; i < languages.length; i++) {
      if(languages[i][key] === value) return languages[i];
    }
    return null;
  }

  getExtension( value, key ) {
    if( this._extensions ) {
      for( let i = 0; i < this._extensions.length; i++) {
        if(this._extensions[i][key] === value) return this._extensions[i];
      }
    }
    return null;
  }
}
export default GamesService.getInstance();